enum NotificationBannerState {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
}

export default NotificationBannerState;
